import React, { Component } from 'react';
import * as XLSX from 'xlsx/xlsx.mjs';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import api from '../../services/api_despesas';
import Swal from 'sweetalert2';
import styles from "./styles.module.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineAssignmentReturn } from "react-icons/md";

class ExcelReader extends Component {

    constructor(props) {

        super(props);
        this.state = {
            file: {},
            data: [],
            cols: [],
            lote: '',
            lotes: [],
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);

        //passo os callbacks que vem de contas.js para a função ExcelReader, o primeiro callback seta a propriedade importar como true para desabilitar os botões
        //o segundo callback seta importando como true para habilitar o spinner, o terceiro seta importando como false para desabilitar o spinner
        this.cb = props.cb;
        this.importando = props.importando;
        this.finalizado = props.finalizado;
        this.orc_cenarios_id = props.orc_cenarios_id;
        this.orc_areas_id = props.orc_areas_id;
        this.deleteLote = props.deleteLote;
        this.returnLote = props.returnLote;
        this.perfil = [];

        props.perfil.map(perf => {
            this.perfil.push(perf.perfil_id);
        });

    }

    componentDidMount() {
        const setlotes = function (lotes) {
            this.setState({ lotes: lotes })
        }.bind(this);

        api.get(`/lote?orc_cenarios_id=${this.orc_cenarios_id}`).then(function (response) {
            if (response.data) {
                setlotes(response.data)
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    handleChange(e) {
        const files = e.target.files;
        if (files && files[0]) this.setState({ file: files[0] });
    };

    handleFile() {
        if (this.state.file.name) {

            this.importando();
            /* Boilerplate to set up FileReader */
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;

            reader.onload = (e) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws);
                /* Update state */

                console.log(wsname);

                //função que chama os callbacks da função principal ao finalizar a importação
                const finish = () => {
                    this.fileInput.value = "";
                    this.finalizado();
                    this.cb();
                }

                this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {

                    var orcamento = [];

                    const headers = Object.keys(this.state.data[0]);

                    const layout = [
                        'ADITIVO_PREVISAO',
                        'AREA_ID',
                        'COD_PRODUTO',
                        'DESCRICAO_PRODUTO',
                        'DESCRICAO_PROJETO',
                        'JUSTIFICATIVA',
                        'OBSERVACAO_PROJETO',
                        'QUANTDADE',
                        'VALOR_UNITARIO',
                        'CENTRO_CUSTO_ID',
                        'CONTA_ID',
                        'DATA_PAGAMENTO',
                        'CONDICAO_PGTO_ID'
                    ]

                    var pass;
                    //VALIDA SE A PLANILHA ESTÁ PREENCHIDA CORRETAMENTE COM OS VALORES OBRIGATÓRIOS
                    layout.forEach((l) => {
                        pass = false;
                        var has = headers.filter(h => h === l);
                        if (has.length === 1) {
                            pass = true;
                            return;
                        }
                    })

                    if (!pass) {
                        Swal.fire(`NÃO É POSSIVEL REALIZAR A IMPORTAÇÃO, O LAYOUT NÃO CONFERE, A PLANILHA DEVE CONTER OBRIGATORIAMENTE E EXATAMENTE COMO ESTÁ AS SEGUINTES COLUNAS: ${JSON.stringify(layout)}`);
                        finish();
                        return;
                    }

                    //REMODELA O OBJETO PARA QUE O PAYLOAD NÃO FIQUE TÃO GRANDE
                    this.state.data.map((d) => {

                        orcamento.push({
                            ADITIVO_PREVISAO: d.ADITIVO_PREVISAO,
                            AREA_ID: d.AREA_ID,
                            COD_PRODUTO: d.COD_PRODUTO,
                            DESCRICAO_PRODUTO: d.DESCRICAO_PRODUTO,
                            DESCRICAO_PROJETO: d.DESCRICAO_PROJETO,
                            JUSTIFICATIVA: d.JUSTIFICATIVA,
                            OBSERVACAO_PROJETO: d.OBSERVACAO_PROJETO,
                            QUANTDADE: d.QUANTDADE,
                            VALOR_UNITARIO: d.VALOR_UNITARIO,
                            CENTRO_CUSTO_ID: d.CENTRO_CUSTO_ID,
                            CONTA_ID: d.CONTA_ID,
                            DATA_PAGAMENTO: d.DATA_PAGAMENTO,
                            CONDICAO_PGTO_ID: d.CONDICAO_PGTO_ID,
                        })
                    })

                    if (this.state.lote === '') {
                        Swal.fire("O LOTE NÃO PODE FICAR EM BRANCO!");
                        finish();
                        return;
                    }
                    const body = {
                        orcamento: orcamento,
                        orc_cenarios_id: this.orc_cenarios_id,
                        lote: this.state.lote,
                    }

                    api.post(`/importacao/industria`, body).then(function (response) {
                        if (response.data) {

                            //FAZ O TRATAMENTO DE ERRO PARA CAPTURAR AS LINHAS COM OS DEVIDOS PROBLEMAS
                            if (response.data.error) {
                                var erro = response.data.error;
                                console.log('erro na integra', erro)


                                var html = '';

                                html = `
                                <table style="font-size:0.7rem;">
                                    <thead>
                                        <tr>
                                            <th style="width:150px;" >LINHA</th>
                                            <th>ERRO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                `;

                                if (Array.isArray(erro)) {
                                    erro.forEach((e) => {
                                        if (e.line) {
                                            html = html + `
                                        <tr>
                                            <td style="width:150px;">${e.line}</td>
                                        `
                                        } else {
                                            html = html + `
                                        <tr>
                                            <td style="width:150px;">ERRO GERAL</td>
                                        `
                                        }

                                        html = html + `
                                            <td>${e.error}</td>
                                        </tr>
                                        `
                                    })

                                    html = html + `
                                    </tbody>
                                    </table>
                                    `
                                }

                                Swal.fire({
                                    width: '100%',
                                    title: 'ERRO!',
                                    icon: 'error',
                                    html: html,
                                    showCloseButton: true,
                                    showCancelButton: true,
                                    focusConfirm: false,
                                    confirmButtonText:
                                        'OK',
                                    confirmButtonAriaLabel: 'OK',
                                })
                            } else {
                                Swal.fire('ARQUIVO IMPORTADO COM SUCESSO!')
                            }
                        }
                    }).catch(function (error) {
                        // handle error
                        alert(error);
                        console.log(error);
                    }).then(function () {
                        // always executed
                        finish();
                    });
                });

            };

            if (rABS) {
                reader.readAsBinaryString(this.state.file);
            } else {
                reader.readAsArrayBuffer(this.state.file);
            };
        } else {
            Swal.fire('NENHUM ARQUIVO SELECIONADO!')
        }
    }

    handleClickLote(lote) {
        // console.log('clicou nesse', lote);
        this.setState({ lote: lote.descricao });
    }

    handleClickDeleteLote(lote) {
        // console.log('deletando esse', lote);
        this.deleteLote(lote);
    }

    handleClickReturnLote(lote) {
        // console.log('estornando esse', lote);
        this.returnLote(lote);
    }

    handlePopup(e) {
        e.currentTarget.children[0].classList.toggle(styles.showpopup)
    }

    renderLotes() {
        // ATIVAR MÓDULO DE DELEÇÃO SOMENTE PARA O PERFIL 5 (Controladoria)
        if(this.perfil.includes(5)) {
            return (
                this.state.lotes.map((lote) => {
                    return (
                        <div className={[styles.lote, styles.lotegrid].join(' ')}>
                            <div className={[styles.optionlote, styles.optionloteleft].join(' ')} onClick={() => this.handleClickLote(lote)}>
                                {lote.descricao}
                            </div>
                            <div className={styles.optionlote} onClick={() => this.handleClickReturnLote(lote)} onMouseEnter={e => this.handlePopup(e)} onMouseLeave={e => this.handlePopup(e)}>
                                <span className={styles.popup}>Estornar Lote</span>
                                <MdOutlineAssignmentReturn className={styles.loteicons} />
                            </div>
                            <div className={[styles.optionlote, styles.optionloteright].join(' ')} onClick={() => this.handleClickDeleteLote(lote)} onMouseEnter={e => this.handlePopup(e)} onMouseLeave={e => this.handlePopup(e)}>
                                <span className={styles.popup}>Deletar Lote</span>
                                <RiDeleteBin6Line className={styles.loteicons}/>
                            </div>
                        </div>
                    )
                })
            )
        }
        else {
            return (
                this.state.lotes.map((lote) => {
                    return (
                        <div className={styles.lote}>
                            <div className={[styles.optionlote, styles.optionlotefull].join(' ')} onClick={() => this.handleClickLote(lote)}>
                                {lote.descricao}
                            </div>
                        </div>
                    )
                })
            )
        }
    }

    render() {
        return (
            <div>
                <label htmlFor="file">SELECIONE A PLANILHA PARA IMPORTAR</label>
                <br />
                <input type="file" className="form-control" id="file" accept={SheetJSFT} onChange={this.handleChange} ref={ref => this.fileInput = ref} />
                <br />
                <label>NOVO LOTE:</label>
                <input type="text" maxLength={20} value={this.state.lote} onChange={(e) => this.setState({ lote: e.target.value })} />
                <br />
                ESCOLHER UM LOTE EXISTENTE:
                <br />
                <div className={styles.gridlotes}>
                    {this.renderLotes()}
                </div>
                <br />
                <div className={styles.areasalign}>
                    <div className={styles.areasalignright}>
                        <input type='submit' value="IMPORTAR" className={styles.btn} onClick={this.handleFile} />
                    </div>
                    <div></div>
                    <div className={styles.areasalignleft}>
                        <input type='submit' value="FECHAR" className={styles.btnclose} onClick={this.cb} />
                    </div>
                </div>
            </div>
        )
    }
}

export default ExcelReader;